import Vue from 'vue'

const state = () => ({
  leadsInfo: {}
})

const getters = { }

const actions = {
  async getLeadsInfo ({ commit }, params) {
    const { baseUrl } = params
    const result = await Vue.$http.get(`/helper/leadsinfo?baseUrl=${baseUrl}`)
    if (result?.status === 200) {
      commit('SET_DATA', ['leadsInfo', result.data?.record])
    }
  },
  async increaseQrImage ({ commit }, params) {
    const { size } = params
    const result = await Vue.$http.get(`/helper/qrlead?size=${size}`)
    if (result?.status === 200) {
      commit('SET_DATA', ['leadsInfo', result.data?.record])
      return result.data?.record
    }
  },
  async downloadQr ({ commit }, params) {
    const { size } = params
    const result = await Vue.$http.get(`/helper/qrleadDownload?size=${size}`, { responseType: 'blob' })
    if (result?.status === 200) {
      return result
    }
  }
}

const mutations = {
  SET_DATA: (state, payload) => {
    const [property, value] = payload
    Vue.set(state, property, value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
